import { useEffect, useState } from "react";
import { Area, AreaChart, CartesianGrid, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";
import { api } from "@/lib/api";

const fmtDay = (d) => { const [, m, day] = d.split("-"); return `${day}/${m}`; };

const Tip = ({ active, payload, label }) => {
  if (!active || !payload?.length) return null;
  return (
    <div className="bg-[#1A1A18] text-[#FAF8F5] text-xs px-3 py-2 rounded-md shadow-lg" data-testid="daily-chart-tooltip">
      <p className="text-[#C2B8A8] mb-1">{fmtDay(label)}</p>
      {payload.map((p) => <p key={p.dataKey} className="flex justify-between gap-4"><span>{p.name}</span><span className="tabular-nums">{p.value}</span></p>)}
    </div>
  );
};

export const DailyChart = () => {
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/admin/analytics/daily", { params: { days: 30 } }).then((r) => setData(r.data.series)).catch(() => setData([])); }, []);
  const totals = (data || []).reduce((a, d) => ({ visits: a.visits + d.visits, routines: a.routines + d.routines }), { visits: 0, routines: 0 });

  return (
    <div className="bg-white border border-[#E2DACF] p-6 mt-6" data-testid="analytics-daily-chart">
      <div className="flex flex-wrap items-end justify-between gap-3 mb-4">
        <div>
          <p className="text-xs text-[#8C8275]">Andamento giornaliero · ultimi 30 giorni</p>
          <p className="font-serif text-2xl mt-1">Visite e routine create</p>
        </div>
        <div className="flex items-center gap-5 text-xs">
          <span className="flex items-center gap-2"><i className="h-2.5 w-2.5 rounded-full bg-[#C5A059]" /> Visite <strong className="tabular-nums font-medium" data-testid="daily-total-visits">{totals.visits}</strong></span>
          <span className="flex items-center gap-2"><i className="h-2.5 w-2.5 rounded-full bg-[#1A1A18]" /> Routine create <strong className="tabular-nums font-medium" data-testid="daily-total-routines">{totals.routines}</strong></span>
        </div>
      </div>
      {!data ? <p className="text-sm text-[#8C8275]">Caricamento…</p> : (
        <div className="h-56 sm:h-64">
          <ResponsiveContainer width="100%" height="100%">
            <AreaChart data={data} margin={{ top: 8, right: 8, left: -22, bottom: 0 }}>
              <defs>
                <linearGradient id="fsVisits" x1="0" y1="0" x2="0" y2="1"><stop offset="0%" stopColor="#C5A059" stopOpacity={0.35} /><stop offset="100%" stopColor="#C5A059" stopOpacity={0} /></linearGradient>
                <linearGradient id="fsRoutines" x1="0" y1="0" x2="0" y2="1"><stop offset="0%" stopColor="#1A1A18" stopOpacity={0.18} /><stop offset="100%" stopColor="#1A1A18" stopOpacity={0} /></linearGradient>
              </defs>
              <CartesianGrid vertical={false} stroke="#F2ECE4" />
              <XAxis dataKey="date" tickFormatter={fmtDay} tick={{ fontSize: 10, fill: "#8C8275" }} tickLine={false} axisLine={{ stroke: "#E2DACF" }} interval={4} />
              <YAxis allowDecimals={false} tick={{ fontSize: 10, fill: "#8C8275" }} tickLine={false} axisLine={false} />
              <Tooltip content={<Tip />} cursor={{ stroke: "#C5A059", strokeDasharray: "3 3" }} />
              <Area type="monotone" dataKey="visits" name="Visite" stroke="#C5A059" strokeWidth={1.8} fill="url(#fsVisits)" dot={false} activeDot={{ r: 3, fill: "#C5A059" }} isAnimationActive />
              <Area type="monotone" dataKey="routines" name="Routine create" stroke="#1A1A18" strokeWidth={1.6} fill="url(#fsRoutines)" dot={false} activeDot={{ r: 3, fill: "#1A1A18" }} isAnimationActive />
            </AreaChart>
          </ResponsiveContainer>
        </div>
      )}
    </div>
  );
};
